<template>
  <v-row class="pb-9">
    <v-col cols="12">
      <slot name="header" />
      <v-row>
        <v-col cols="12" md="10" class="pa-4 pl-0 ml-0">
          <BaseFormInput
            id-element="group-name"
            placeholder="Insira um nome para o grupo"
            v-model="value.nome"
            required
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Nome do Grupo"
          />
        </v-col>
      </v-row>
      <v-row class="pl-0 ml-0">
        <v-col cols="10" class="pa-4 pl-0 ml-0">
          <p class="body-2 font-weight-bold primary--text mb-2">
            Adicionar logo do Grupo Econômico
          </p>
          <BaseFileInput
            :multiple="false"
            :item="getLogo"
            @update="updateLogo"
          />
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12" sm="12" class="d-flex">
          <BaseButton
            class="secondary justify-center-end px-4 pl-4"
            @click="copyText"
          >
            <v-icon color="grayscale" size="20" v-on="on" class="pr-2">
              fa-thin fa-copy
            </v-icon>
            Copiar link convidado
          </BaseButton>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";

export default {
  name: "EconomicGroupDetails",
  props: {
    value: {
      type: Object
    }
  },
  data: () => ({
    requiredInput
  }),
  computed: {
    getLogo() {
      if (this.value?.logo_url != null) {
        return { nome: "Logotipo", url: this.value.logo_url };
      }
      return null;
    }
  },
  methods: {
    updateLogo(value) {
      this.value.logo = value;
    },
    copyText() {
      let link;

      if (process.env.NODE_ENV == "debuglocal") {
        link = `http://localhost:8080/nova-cotacao/agro/${this.value.id}`;
      }
      if (process.env.NODE_ENV == "development") {
        link = `https://agro-dev.lockton.com.br/nova-cotacao/agro/${this.value.id}`;
      }
      if (process.env.NODE_ENV == "homolog") {
        link = `https://agro-homolog.lockton.com.br/nova-cotacao/agro/${this.value.id}`;
      }

      if (process.env.NODE_ENV == "production") {
        link = `https://agro.lockton.com.br/nova-cotacao/agro/${this.value.id}`;
      }

      navigator.clipboard.writeText(link);

      this.showAlertNotification({
        message: "Dados copiados para a área de transferência.",
        type: "info"
      });
    }
  }
};
</script>
